module.exports = __webpack_public_path__ + "static/media/backTogether.fa5cfe5a.jpg";